<template>
    <div class="m-leader-form">
        <div class="sign-up-tab">
            <div class="tab-hd">
                <div class="u-btn" :class="{'act' : index==0}" @click="index=0">队伍信息</div>
                <div class="u-btn" :class="{'act' : index==1}" @click="index=1">队员信息</div>
            </div>

            <div class="form-view">
                <div class="team-info" v-show="index==0">                   
                        <div class="base-info">
                            <el-form ref="teamInfoForm" :model="form" :rules="team_rules" label-width="280px">
                                <el-form-item label="比赛大区" prop="zid">
                                    <el-select v-model="form.zid" placeholder="请选择比赛大区" @change="queryPlayerInfo(leader_form.account)">
                                        <el-option v-for="(item,index) in area_data" :key="index" v-bind:label="item.name" v-bind:value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="战队名称" prop="name">
                                    <el-input v-model="form.name"></el-input>
                                </el-form-item>
                            </el-form> 
                        </div>
                        <div class="leader-info">
                            <el-form ref="leaderForm" :model="leader_form" :rules="rules" label-width="280px">
                                <el-form-item label="游戏ID" prop="account">
                                    <el-input v-model="leader_form.account" @blur="queryPlayerInfo(leader_form.account)" :readonly="true" :disabled="true"></el-input>
                                </el-form-item>

                                <el-form-item label="游戏昵称" prop="nick">
                                    <el-input v-model="leader_form.nick" :readonly="true" :disabled="true"></el-input>
                                </el-form-item>

                                <el-form-item label="所属军团" prop="corpName">
                                    <el-input v-model="leader_form.corpName" :readonly="true" :disabled="true"></el-input>
                                </el-form-item>

                                <el-form-item label="账号历史最高神兵值" prop="maxEquipScore">
                                    <el-input v-model.number="leader_form.maxEquipScore" :readonly="true" :disabled="true"></el-input>
                                </el-form-item>

                                <el-form-item label="真实姓名" prop="realName">
                                    <el-input v-model="leader_form.realName"></el-input>
                                </el-form-item>                             

                                <el-form-item label="手机号码" prop="phone">
                                    <el-input v-model="leader_form.phone"></el-input>
                                </el-form-item>

                                <el-form-item label="身份证号码" prop="idCard">
                                    <el-input v-model="leader_form.idCard"></el-input>
                                </el-form-item>

                                <el-form-item label="QQ号码" prop="qq">
                                    <el-input v-model="leader_form.qq"></el-input>
                                </el-form-item>
                            </el-form>                                                          
                        </div>                                                            
                </div>
                <div class="memmber-info" v-show="index==1">
                    
                    <div class="member-list">
                        <div class="member-item" v-for="(player,index) in member_form.member" :key="index">
                            <div class="input-item">
                                <span class="label">队员{{ index+1 }} 游戏ID：</span>
                                <div class="m-input"><input type="text" v-model="player.id" placeholder="数字ID" @blur="queryMemberInfo(player.id,index,player)"></div>
                            </div>
                            <div class="input-item">
                                <span class="label">玩家昵称：</span>
                                <div class="m-input"><input type="text" v-model="player.nick" placeholder="匹配出昵称" :readonly="true" :disabled="true"></div>
                            </div>
                        </div>
                    </div>

                    <div class="member-list">
                        <div class="member-item" v-for="(player,index) in member_form.backup" :key="index">
                            <div class="input-item">
                                <span class="label">替补{{ index+1 }} 游戏ID：</span>
                                <div class="m-input"><input type="text" v-model="player.id" placeholder="数字ID" @blur="queryMemberInfo(player.id,index,player)"></div>
                            </div>
                            <div class="input-item">
                                <span class="label">玩家昵称：</span>
                                <div class="m-input"><input type="text" v-model="player.nick" placeholder="匹配出昵称" :readonly="true" :disabled="true"></div>
                            </div>
                        </div>
                    </div>                    

                </div>
            </div>
        </div>

        <div class="check-view">
            <div class="v-code"><span class="tag">验证码：</span><div class="input"><input type="text" name="vcode" @blur="vcheck" v-model="vcode"></div><span class="img-box"><img v-bind:src="img"></span><span class="vcode-flesh" @click="re_code">换一个</span></div>
            <div class="check-box"><em class="box"><input type="checkbox" name="rule-check" v-model="rule_check"></em><span class="u-rule"><a href="http://www.m3guo.com/v2/news/report/1637134975.html?v=1" target="_blank">我已阅读并同意遵守《军团出征赛事规则》</a></span></div>
        </div>
        <div class="u-btn submit" @click="submitForm">确认提交</div>       
    </div>
</template>


<script>
  import axios from 'axios';
  import global from '@/assets/js/global.js';
  import { Message } from 'element-ui';

  let leader_id = 0;

  export default {
    data() {
      return {
        index : 0,
        member_cofig : {
            member : 9,
            backup : 2,
        },
        form : {
            zid : '',
            name : '',
        },
        leader_form : {
            account : '',
            nick : '',
            corpName : '',
            corpId : '',
            maxEquipScore : '',
            realName : '',
            phone : '',
            idCard : '',
            qq : '',
        },
        member_form : {
            member : [],
            backup : [],
        },
        team_rules : {
            name: [{
                required: true,
                message: '*请输入战队名称',
                trigger: 'blur'
                },
                {
                min: 1,
                max: 5,
                message: '* 请输入字母数字汉字且长度在5个字符以内的名称',
                trigger: 'blur'
                },
                {
                validator(rule, value, callback,source) {
                    axios.get(global.ajax_url_map.word,{
                        params : {
                            word : value,
                        }
                    })
                    .then(res => {
                        if(res.data.code == global.ajax_states.success){
                            if(res.data.data.state){
                                Message.error('名称不符合要求，请重新输入');
                                callback(new Error('* 名称不符合要求，请重新输入'));                               
                            }
                            else{
                                if(name.length <= 5){
                                    //Message.success('恭喜您，该战队名可以使用');
                                    callback();                  
                                }
                            }
                        }
                        else{
                            Message.error('请稍后再试');
                            callback(new Error('* 请稍后再试'));
                        }
                    });                    
                },
                trigger: 'blur'
                }                
            ],
            zid: [{
                required: true,
                message: '*请选择比赛大区',
                trigger: 'change'
            }],            
        },
        rules: this.$global.formRules,
        area_data : this.$global.areaList,
        wordcheck : true,
        vcode : '',
        bcheck : '',
        img : this.$ajax_url_map.vcode,
        validate_1 : false,
        validate_2 : false,
        rule_check : false,
      };
    },
    props : {
        ua : {
            default : ()=>{},
        }
    },    
    created (){
        // {account : '',nickName: ''}
        for(var i = 0 ; i < 9; i++){
            this.member_form.member.push({id : '',nick: ''});
        }

        for(var i = 0 ; i < 2; i++){
            this.member_form.backup.push({id : '',nick: ''});
        }
        
        this.leader_form.account = this.ua.uid;
    },
    watch: {
        'leader_form.account' : function (newVal) {
            leader_id = newVal;
        }
    },  
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      queryPlayerInfo (id){
          if(!id)return;
          if(!this.form.zid)return;

          let self = this;

          this.$axios.get(this.$ajax_url_map.query,{
              params : {
                  account : this.leader_form.account,
                  zid : this.form.zid,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success){
                  //success
                  self.leader_form.nick = res.data.data.charName;
                  self.leader_form.maxEquipScore = res.data.data.equipScoreMax;
                  self.leader_form.corpName = res.data.data.corpName;
                  self.leader_form.corpId = res.data.data.corpid;
                  this.$message.success('查询成功');
              }
              else{
                  self.leader_form.nick = '';
                  self.leader_form.maxEquipScore = '';
                  self.leader_form.corpName = '';
                  self.leader_form.corpId = '';                
                  this.$message.error(res.data.message);
              }
          });
      },
      queryMemberInfo (id,pos,data){

          if(!this.form.zid || !id){
              data.id = '';
              if(!this.form.zid)return this.$message.error('请先选择比赛大区');
              if(!id)return data.nick = '';         
          };
          

          if(id == this.leader_form.account){
              data.id = '';
              data.nick = '';
              return this.$message.error('玩家ID与队长ID重复');
          }

          let self = this;

          this.$axios.get(this.$ajax_url_map.query,{
              params : {
                  account : id,
                  zid : this.form.zid,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success){
                  //success
                  if( res.data.data.equipScoreMax < this.$global.equipScore_quire){
                    data.id = '';
                    data.nick = '';
                    return this.$message.error('玩家神兵要求不符');                      
                  }
                  data.nick = res.data.data.charName;
                  data.maxEquipScore = res.data.data.equipScoreMax;
                  data.corpName = res.data.data.corpName;
                  data.corpId = res.data.data.corpid;
                  this.$message.success('查询成功');
              }
              else{
                  data.id = '';
                  data.nick = '';
                  data.maxEquipScore = '';
                  data.corpName = '';
                  data.corpId = '';                 
                  this.$message.error(res.data.message);
              }
          });
      },      
      checkTeamName (name){
          if(!name)return false;
          this.$axios.get(this.$ajax_url_map.word,{
              params : {
                  word : name,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success){
                  if(res.data.data.state){
                    this.form.name = res.data.data.target;
                    this.$message.error('名称不符合要求，请重新输入');
                    this.wordcheck = false;
                  }
                  else{
                    this.wordcheck = true;
                    if(name.length <= 5){
                        //this.$message.success('恭喜您，该战队名可以使用');                   
                    }

                  }
              }
              else{
                  this.$message.error('请稍后再试');
                  this.wordcheck = false;
              }
          });
      },
      submitForm (){
        var self = this;

        if(!this.rule_check)return this.$message.error('请确认阅读并同意遵守军团出征赛事规则');
        if(!this.bcheck )return this.$message.error('请填写验证码');

        console.log(this.member_form.member.length);
        if(this.member_form.member.filter(function(e){return e.id > 0}).length < 9)return this.$message.error('队员人数不足');
        if(refrain(this.member_form.member.filter(function(e){return e.id > 0})).length > 0)return this.$message.error('队员ID重复');
        if(refrain(this.member_form.backup.filter(function(e){return e.id > 0})).length > 0)return this.$message.error('替补队员ID重复');

        this.form_check ('teamInfoForm','validate_1');
        this.form_check ('leaderForm','validate_2');

        if(this.form.zid && this.form.name && this.validate_2){
            let data = {
                zid : this.form.zid,
                name : this.form.name,
                leader : this.leader_form,
                players: this.member_form.member,
                substitutes : this.member_form.backup.filter(function(e){return e.id > 0}),                  
            };

            this.$axios({
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'post',
                url: this.$ajax_url_map.creat,
                data: JSON.stringify(data)
            })
            .then(res => {
                if(res.data.code == this.$ajax_code.success){
                    this.$emit('destory_all',['inner']);
                    this.$ua_update({
                        role : 1,
                        state : true,
                    });

                    this.$success_modal({
                        code : res.data.data,
                    });
                }
                else{
                    this.$message.error(res.data.message);
                }
            })
            .catch(err=>{
                this.$message.error('请稍后再试');
                console.error(err);
            })          
        }
        else{
            console.log('表单验证失败');
            console.log(this.validate_1);
            console.log(this.validate_2);
            this.$message.error('队员参赛条件不符，请查看赛事规则并检查队员ID');
        }

        //查重
        function refrain(arr) {
            var tmp = [];
            if(arr.length == 0)return [];
            　　
        　　if(Array.isArray(arr)) {
        　　　　arr.concat().sort().sort(function(a,b) {
        　　　　　　if(a.id==b.id && tmp.indexOf(a) === -1) tmp.push(a);
        　　　　});
        　　}
        　　return tmp;
        }        
        
      },
      form_check (name,key){
        var self = this; 
        this.$refs[name].validate((valid) => {
          if(valid){
              self[key] = true;
          }
        });
      },
      vcheck (){
          if(!this.vcode)return;
          this.$axios.get(this.$ajax_url_map.vcode_check,{
              params : {
                  captcha : this.vcode,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success && res.data.data){
                  this.bcheck = true;
              }
              else{
                  this.$message.error('验证码有误');
              }              
          });
      },
      re_code (){
          this.img = this.$ajax_url_map.vcode + '?r=' + new Date().getTime();
      },
    }
  };
</script>

<style scoped>
.sign-up-tab .tab-hd{
    display: flex;
}

.sign-up-tab .tab-hd .u-btn{
    width: 50%;
    height: 82px;
    line-height: 82px;
    text-align: center;
    font-size: 24px;
    color: #fefefe;
    background-color: #2f2f2f;
}

.sign-up-tab .tab-hd .u-btn.act{
    background-color: #650101;
}

.base-info{
    position: relative;
    margin-bottom: 20px;
    padding: 50px 0 15px;
    border-bottom: 1px solid #e5e5e5;
}

.base-info::after{
    content: '';
    display: block;
    position: absolute;
    left: 50px;
    top: 45px;
    width: 99px;
    height: 99px;
    background-image: url(../assets/images/icon-team.png);
}

.leader-info{
    position: relative;
}

.leader-info::after{
    content: '';
    display: block;
    position: absolute;
    left: 50px;
    top: 5px;
    width: 99px;
    height: 99px;
    background-image: url(../assets/images/icon-leader_form.png);
}

.base-item{
    margin-bottom: 10px;
}

.member-list{
    display: flex;
    flex-wrap: wrap;
    padding: 45px 30px 0;
}

.member-list .member-item{
    width: 33%;
    margin-bottom: 50px;
    font-size: 24px;
    color: #2f2f2f;
}

.member-item .label{
    display: inline-block;
    vertical-align: middle;
    width: 170px;
    text-align: right;    
}

.member-item .m-input{
    display: inline-block;
    vertical-align: middle;
    width: 180px;
}

.member-item .input-item{
    margin-bottom: 25px;
}

.member-item .m-input input{
    display: block;
    width: 100%;
    font-size: 24px;
    padding-left: 20px;
    box-sizing: border-box;
}

.m-leader-form{
    padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/leaderForm.vue